__webpack_require__.p = "https://mungi.eu-4.evennode.com/build/";